var map = {
	"./Character.svg": 31,
	"./certification-icon.svg": 5,
	"./education-icon.svg": 4,
	"./github.svg": 32,
	"./language-icon.svg": 6,
	"./linkedin.svg": 33,
	"./projects-icon.svg": 8,
	"./skills-icon.svg": 9,
	"./work-experience-icon.svg": 7
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;